// Review toolbar: find box, only-issues toggle, counts, add-row.

import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui';

export function ReviewToolbar({
  search,
  onSearchChange,
  onlyIssues,
  onToggleOnlyIssues,
  visibleCount,
  totalCount,
  onAddRow,
  atRowCap,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  onlyIssues: boolean;
  onToggleOnlyIssues: (value: boolean) => void;
  visibleCount: number;
  totalCount: number;
  onAddRow: () => void;
  atRowCap: boolean;
}) {
  const { t } = useTranslation('inventory-import');
  return (
    <div className="flex flex-wrap items-center gap-3">
      <input
        type="search"
        aria-label={t('toolbar.find_aria')}
        placeholder={t('toolbar.find_placeholder')}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="rounded-md border border-neut-border px-3 py-1.5 text-sm text-neut-prim focus:border-prim focus:outline-none"
      />
      <label className="flex items-center gap-1.5 text-sm text-neut-prim">
        <input
          type="checkbox"
          checked={onlyIssues}
          onChange={(e) => onToggleOnlyIssues(e.target.checked)}
        />
        {t('toolbar.only_issues')}
      </label>
      <span className="text-xs text-neut-sec">
        {t('toolbar.showing', { visible: visibleCount, total: totalCount })}
      </span>
      <div className="ml-auto flex items-center gap-2">
        {atRowCap && (
          // A disabled button swallows hover, so its tooltip never shows; explain the cap inline.
          <span className="text-xs text-neut-sec">
            {t('toolbar.add_row_disabled')}
          </span>
        )}
        <Button
          variant="secondary"
          size="sm"
          width="auto"
          onClick={onAddRow}
          disabled={atRowCap}
        >
          {t('toolbar.add_row')}
        </Button>
      </div>
    </div>
  );
}
